import { workspaceHref } from "./workspace-route"

export function reportPreviewPath(projectID: string, artifactID: string, companyID: string) {
  const query = new URLSearchParams({ company: companyID })
  return workspaceHref(`/reports/${encodeURIComponent(projectID)}/${encodeURIComponent(artifactID)}/preview?${query}`)
}

export function reportDisplayTitle(title: string) {
  return title.replace(/\.html?$/i, "")
}

export function reportFormatLabel(format: string, reportLabel: string) {
  return /^(html|htm|text\/html)$/i.test(format.replace(/^\./, "")) ? reportLabel : format.toUpperCase()
}
